import React from 'react';

import { Box, Button, Grid, Link, Typography } from '@material-ui/core';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';

import TrailerIcon from '../../../../assets/img/assistance/circle_crane_icon.svg';
// import TrailerIcon from '../../../../assets/img/trailer.png';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import {
  ZOOM_DEFAULT, // TRAVEL_MODE,
} from '../../../../constants/maps.constant';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';

const libraries: (
  | 'places'
  | 'drawing'
  | 'geometry'
  | 'localContext'
  | 'visualization'
)[] = ['places'];

const StatusOnRoad = () => {
  const { setOpen, success } = useAssistanceDataContext();
  const { assistance_status } = success;

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string, // ,
    libraries,
    language: 'es',
    region: 'ar',
  });

  return (
    <>
      <Grid item xs={12} md={4}>
        <Grid
          container
          justify="center"
          alignItems="center"
          style={{ height: '100%' }}
        >
          <Grid item xs={12}>
            <Box mt={4} mb={2} textAlign="center">
              <Typography variant="h6">
                La grúa llegará{' '}
                {assistance_status.estimated_time
                  ? `en ${assistance_status.estimated_time} minutos`
                  : `pronto`}
              </Typography>
            </Box>
            <Box mb={4} textAlign="center">
              <Typography variant="caption">
                Móvil {assistance_status?.trailer?.license_plate || ''}
              </Typography>
              <Box my={1}>
                <Typography variant="caption">
                  Recordá tener la documentación obligatoria para el traslado.
                </Typography>
              </Box>
            </Box>
          </Grid>
          {assistance_status.cancelable ? (
            <Grid item xs={6} md={9}>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                onClick={() => setOpen(true)}
              >
                Cancelar pedido
              </Button>
            </Grid>
          ) : null}
          <Grid xs={12}>
            <Grid container justify="center">
              <Grid item xs={6} md={9}>
                ¿Necesitás comunicarte con la grúa? Llamá al
                <Link
                  href={`tel:${assistance_status.provider_phone}`}
                  rel="noopener"
                  target="_blank"
                >
                  <Typography
                    component="span"
                    display="inline"
                    align="left"
                    color="secondary"
                  >
                    {assistance_status.provider_phone}
                  </Typography>
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={8}>
        <Box position="relative" width="100%" height="100%">
          <Box
            display={
              !isLoaded &&
              !!assistance_status?.trailer?.latitude &&
              !!assistance_status?.trailer?.longitude
                ? 'block'
                : 'none'
            }
          >
            <Loader action={'Cargando mapa'}></Loader>
          </Box>
          {isLoaded &&
          !!assistance_status?.trailer?.latitude &&
          !!assistance_status?.trailer?.longitude ? (
            <GoogleMap
              id="assitance-map"
              mapContainerStyle={{
                minHeight: '450px',
                height: '100%',
                width: '100%',
              }}
              center={{
                lat: Number(assistance_status.trailer.latitude),
                lng: Number(assistance_status.trailer.longitude),
              }}
              zoom={ZOOM_DEFAULT}
            >
              <Marker
                icon={TrailerIcon}
                position={{
                  lat: Number(assistance_status.trailer.latitude),
                  lng: Number(assistance_status.trailer.longitude),
                }}
                // label={"Hasta"}
                title={'Hasta'}
              />
            </GoogleMap>
          ) : null}
        </Box>
      </Grid>
    </>
  );
};

export default StatusOnRoad;
